import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

declare var gtag;

@Injectable()
export class GoogleAnalyticsService {
  /***************Constructor***************/
  constructor(private datePipe:DatePipe) { }
  /***************Constructor***************/

  /***************Helper Methods***************/
  logSearch(searchTerm) {
    gtag('event', 'view_search_results', {
      'search_term': searchTerm
    });
  }
  logUnauthSearch(searchproduct) {
    gtag('event', 'search_results', {
      'event_category': 'unauth_product_catalog',
      'event_label': searchproduct

    });
  }
  logTypeOfCustomer(typesOfCustomers) {
    console.log(typesOfCustomers)
    gtag('event', 'customer_type', {
      'event_category': 'unauth_product_catalog',
      'event_label': typesOfCustomers,
      'created':this.datePipe.transform(new Date(),'MMM d, y, h:mm a')
    });
  }
  logTypeOfCurrentCustomer(typesOfCustomers) {
    gtag('event', 'current_customer', {
      'event_category': 'unauth_product_catalog',
      'event_label': typesOfCustomers
    });
  }
  logPurchase(submitResponseArray, accountNum) {
    for (let j = 0; j < submitResponseArray.length; j++) {
      const submitResponse = submitResponseArray[j];

      const gtagData = {
        'transaction_id': accountNum,
        'affiliation': accountNum,
        'value': submitResponse.total,
        "currency": "USD",
        'tax': submitResponse.stateTax + submitResponse.tax,
        "shipping": 0,
        "items": []
      }

      const gtagItems = [];

      for (let i = 0; i < submitResponse.orderDetails.length; i++) {
        const product = submitResponse.orderDetails[i];
        gtagItems.push({
          "id": accountNum + ' - ' + product.itemId,
          'name': product.productDesc,
          'brand': product.brandName,
          'price': product.currentPrice,
          'quantity': product.orderQuantity,
          "list_position": i + 1
        });
      }

      gtagData.items = gtagItems;

      gtag('event', 'purchase', gtagData);
    }
  }

  logPromotionClick(promotion) {
    gtag('event', 'select_content', {
      "promotions": [
        {
          "id": promotion.categoryId,
          "name": promotion.name
        }
      ]
    });
  }

  logAddToCart(productData: any[], accountNum) {

    const orderDetails = productData;
    const productDetails = [];

    for (let i = 0; i < orderDetails.length; i++) {
      const product = orderDetails[i];
      productDetails.push({
        "id": accountNum + ' - ' + product.id,
        "name": product.name,
        "brand": product.brand,
        "quantity": product.quantity,
        "price": product.price
      })
    }
    gtag('event', 'add_to_cart', {
      "items": productDetails
    });
  }

  reccomAddToCart(products, type, accountNum) {
    gtag("event", type, {
      'event_category': 'Add_to_cart_product_recommendation',
      'event_label': accountNum + ' - ' + products[0].itemId+' - '+products[0].description +' - '+products[0].cartQuantity +' - $'+products[0].price,
      'add_to_cart_value':products[0].cartQuantity*products[0].price
    });
    // gtag("event", type, {
    //   'event_category':'Add_to_cart_product_recommendation',
    //   'event_label': products[0].brandName
    // });
    // gtag("event", 'Quantity', {
    //   'event_category': type,
    //   'event_label': parseFloat(products[0].cartQuantity)
    // });
    // gtag("event",type, {
    //   'event_category': 'Add_to_cart_product_recommendation',
    //   'event_label': parseFloat(products[0].price)
    // });
  }

  recomView(products, type, accountNum) {
    products.forEach(e => {
     let qty=e.availableQty?e.availableQty:0;
      gtag("event", type, {
        'event_category': 'view_product_recommendation',
        'event_label': accountNum + ' - ' +e.itemId+' - '+e.description+ ' - '+qty+' - $' +e.price
      });
    });
  }
  recomViewByItem(itemId, type, accountNum,price,description,availableQty) {
      gtag("event", type, {
        'event_category': 'view_product_recommendation_by_item',
        'event_label': accountNum + ' - ' +itemId+' - '+description+ ' - '+availableQty+' - $' +price,
        'add_to_cart_value':availableQty*price
    });
  }
  recomLogPurchase(products, type, accountNum) {
    products.forEach(e => {
      gtag("event", type, {
        'event_category': 'purchase_product_recommendation',
        'event_label': accountNum + ' - ' +e.itemId+' - '+e.description +' - '+e.cartQuantity +' - $' +e.price,
        'add_to_cart_value':e.cartQuantity*e.price
      });
    });
  }
  recomRemoveCart(products, type, accountNum) {
    products.forEach(e => {
      if(e.addedFromProductRecommended!='0'){
        type=e.addedFromProductRecommended=='1'?'Top_Recommended_Products':'Top_Cust_Recommended_Products';
      gtag("event", type, {
        'event_category': 'remove_from_cart_product_recommendation',
        'event_label': accountNum + ' - ' + e.itemId+' - '+e.productDesc +' - '+e.availableQuantity  +' - $'+e.currentPrice,
        'add_to_cart_value':e.availableQuantity*e.currentPrice
      });
    }
    });
  }

  promotionPop(products, type) {
    gtag("event", type, {
      'event_category': 'promotion_popup',
      'event_label': products.itemId+ ' - ' +products.cartQuantity+ ' - $' +products.price
  });
  }
  promotionPopSale(products, type) {
    gtag("event", type, {
      'event_category': 'promotion_popup',
      'event_label': products.itemId+ ' - ' +products.cartQuantity+ ' - $' +products.currentPrice
  });
  }
  promotionPopClick( type) {
    gtag("event", type+"_click", {
      'event_category': 'promotion_popup',
      'event_label': type
  });
  }

  logViewProduct(product: any, accountNum) {
    gtag('event', 'view_item', {
      "items": [
        {
          "id": accountNum + ' - ' + product.itemId,
          "name": product.description,
          "brand": product.brandName,
          "price": product.price
        }
      ]
    });
  }

  logBeginCheckout(orderData: any, accountNum) {

    const orderDetails = orderData.orderDetails;
    const productDetails = [];

    for (let i = 0; i < orderDetails.length; i++) {
      const product = orderDetails[i];
      productDetails.push({
        "id": accountNum + ' - ' + product.itemId,
        "name": product.productDesc,
        "brand": product.brandName,
        "quantity": product.orderQuantity,
        "price": product.currentPrice
      })
    }

    gtag('event', 'begin_checkout', {
      "items": productDetails
    });
  }

  logRemoveFromCart(orderData: any, accountNum) {

    const orderDetails = orderData.orderDetails;
    const productDetails = [];
    for (let i = 0; i < orderDetails.length; i++) {
      const product = orderDetails[i];
      productDetails.push({
        "id": accountNum + ' - ' + product.itemId,
        "name": product.productDesc,
        "brand": product.brandName,
        "quantity": product.orderQuantity,
        "price": product.currentPrice
      })
    }
    gtag('event', 'remove_from_cart', {
      "items": productDetails
    });
  }

  /***************Helper Methods***************/
}
